const receiptNumberHelper = (receiptNumber) =>
    `${receiptNumber.substring(0, 4)} ${receiptNumber.substring(4, 8)} ${receiptNumber.substring(8, 11)} ${receiptNumber.substring(11)}`;

module.exports = receiptNumberHelper;
